import React from 'react'
import { PaginaType } from 'utils/types'
import {
  Page,
  RoundHead,
  ImpegnoSection1,
  ImpegnoSection2,
  ImpegnoSection3,
  ImpegnoSection4,
  ImpegnoSection5,
  ImpegnoSection6,
} from '@components/organisms'
import { useSelector } from 'react-redux'
import styles from './ImpegnoTemplate.module.sass'

interface Props {
  pagina: PaginaType
}

const ImpegnoTemplate = (props: Props) => {
  const { pagina } = props

  const mockItems = [
    {
      name: 'Siamo un paese in <strike>dolce</strike> attesa',
      description:
        '<p>Dolce attesa? O solo attesa? Le coppie italiane ritardano sempre più la costruzione di un progetto di vita e fanno sempre meno figli: meno di quanti vorrebbero, sempre più figli unici. </p><p>E le cause sono sempre le stesse:</p>',
      children: [
        {
          pk: 1,
          name: 'Disoccupazione giovanile',
          description: '<p>È sempre più difficile per i giovani ottenere stabilità lavorativa.</p>',
        },
        {
          pk: 2,
          name: 'Sottocupazione femminile',
          description: '<p>È sempre più difficile per i giovani ottenere stabilità lavorativa.</p>',
        },
        {
          pk: 3,
          name: 'Welfare insufficiente',
          description: '<p>È sempre più difficile per i giovani ottenere stabilità lavorativa.</p>',
        },
      ],
    },
    {
      name: 'Da 100 anni dalla parte dei genitori.',
      children: [
        {
          pk: 1,
          name: 'Il nostro pensiero',
          description:
            '<p>Pensiamo che tutti abbiano il diritto di scegliere di avere figli e che si debbano creare le condizioni perché questo accada.</p>',
        },
        {
          pk: 2,
          name: 'Il nostro pensiero',
          description:
            '<p>Pensiamo che tutti abbiano il diritto di scegliere di avere figli e che si debbano creare le condizioni perché questo accada.</p>',
        },
        {
          pk: 3,
          name: 'Il nostro pensiero',
          description:
            '<p>Pensiamo che tutti abbiano il diritto di scegliere di avere figli e che si debbano creare le condizioni perché questo accada.</p>',
        },
      ],
    },
    {
      name: 'Il nostro impegno, in azienda',
      description:
        'Mellin, come azienda del gruppo Danone, si schiera da sempre dalla parte dei genitori. Non solo perché da più di 100 anni supporta la corretta nutrizione dei bambini, ma anche attraverso un percorso etico, iniziato oltre 11 anni fa, di scelte aziendali volte a supportare la genitorialità. Scelte che coinvolgono 500 persone in azienda su tutto il territorio nazionale. Siamo convinti che non si debba aspettare il momento giusto per poter diventare genitori.',
      children: [
        {
          pk: 1,
          description:
            '<p>“Nel 2011, con il coraggio derivante dalla mia esperienza di neo-mamma, avevo un sogno: mettere fine al paradigma che vede le mamme che lavorano divise fra l’aspirazione di far carriera e l’accudimento della propria famiglia. Ho voluto abbattere un tabù e parlare di maternità per cambiare una consuetudine ancora molto radicata nel nostro Paese e che vede la donna non supportata nel ruolo di mamma al lavoro.”</p><p style="text-align: right"><strong>- <a href="#">Sonia Malaspina</a>, HR Director Mellin</strong></p>',
        },
      ],
    },
    {
      name: 'Cosa facciamo per le nostre persone:',
      description:
        'Mellin, come azienda del gruppo Danone, si schiera da sempre dalla parte dei genitori. Non solo perché da più di 100 anni supporta la corretta nutrizione dei bambini, ma anche attraverso un percorso etico, iniziato oltre 11 anni fa, di scelte aziendali volte a supportare la genitorialità. Scelte che coinvolgono 500 persone in azienda su tutto il territorio nazionale. Siamo convinti che non si debba aspettare il momento giusto per poter diventare genitori.',
      children: [
        {
          pk: 1,
          style: 'welfare-illustration',
          description:
            '<p>Investiamo sulle nostre persone dimostrando che le competenze legate alle cura restituiscano professionisti migliori alle organizzazioni: nell’ultimo anno il 12% di promozioni è andato a neo-mamme rientrate dal congedo</p>',
        },
        {
          pk: 2,
          style: 'clessidra-illustration',
          description:
            '<p>Investiamo sulle nostre persone dimostrando che le competenze legate alle cura restituiscano professionisti migliori alle organizzazioni: nell’ultimo anno il 12% di promozioni è andato a neo-mamme rientrate dal congedo</p>',
        },
        {
          pk: 3,
          style: 'coccarda-illustration',
          description:
            '<p>Investiamo sulle nostre persone dimostrando che le competenze legate alle cura restituiscano professionisti migliori alle organizzazioni: nell’ultimo anno il 12% di promozioni è andato a neo-mamme rientrate dal congedo</p>',
        },
        {
          pk: 4,
          style: 'manager-donna-illustration',
          description:
            '<p>Investiamo sulle nostre persone dimostrando che le competenze legate alle cura restituiscano professionisti migliori alle organizzazioni: nell’ultimo anno il 12% di promozioni è andato a neo-mamme rientrate dal congedo</p>',
        },
        {
          pk: 5,
          style: 'laurea-illustration',
          description:
            '<p>Investiamo sulle nostre persone dimostrando che le competenze legate alle cura restituiscano professionisti migliori alle organizzazioni: nell’ultimo anno il 12% di promozioni è andato a neo-mamme rientrate dal congedo</p>',
        },
        {
          pk: 6,
          style: 'parental-policy-illustration',
          description:
            '<p>Investiamo sulle nostre persone dimostrando che le competenze legate alle cura restituiscano professionisti migliori alle organizzazioni: nell’ultimo anno il 12% di promozioni è andato a neo-mamme rientrate dal congedo</p>',
        },
        {
          pk: 7,
          style: 'welfare-illustration',
          description:
            '<p>Investiamo sulle nostre persone dimostrando che le competenze legate alle cura restituiscano professionisti migliori alle organizzazioni: nell’ultimo anno il 12% di promozioni è andato a neo-mamme rientrate dal congedo</p>',
        },
        {
          pk: 8,
          style: 'welfare-illustration',
          description:
            '<p>Investiamo sulle nostre persone dimostrando che le competenze legate alle cura restituiscano professionisti migliori alle organizzazioni: nell’ultimo anno il 12% di promozioni è andato a neo-mamme rientrate dal congedo</p>',
        },
      ],
    },
    {
      name: 'Il nostro impegno,<br />per tutti i genitori',
      description:
        '<p>L’impegno di Mellin non si limita a ciò che facciamo in azienda. Ispirati da quel 7% di nascite in più, abbiamo deciso di portare il nostro supporto anche a tutti i genitori d’Italia.</p>' +
        '<p>Come? Con Parto e Riparto, un servizio di consulenza psicologica, gratuito e aperto a tutti indipendentemente dall’acquisto di un prodotto per supportare neo mamme e papà nell’approccio alla genitorialità, e giuslavoristica, per fornire supporto legale e favorire il reinserimento nel mondo del lavoro.</p>',
      url: '#',
      ctaLabel: 'Scopri il servizio Parto e Riparto',
    },
    {
      name: 'Insieme nutriamo il nostro futuro',
      description:
        'Ma il nostro impegno non finisce qui. Nutrire il futuro è una mission che abbraccia la società, i bambini, il pianeta e gli altri temi che ci proietteranno nel futuro.',
      children: [
        {
          pk: 1,
          name: 'La società',
          style: 'societa-illustration',
          description:
            '<p>Aiutiamo le nuove famiglie a gestire tutti gli aspetti della genitorialità.</p>',
          ctaLabel: 'Parto e Riparto',
          url: '#',
        },
        {
          pk: 2,
          name: 'I bambini',
          style: 'bambini-illustration',
          description:
            '<p>Aiutiamo le nuove famiglie a gestire tutti gli aspetti della genitorialità.</p>',
          ctaLabel: 'I nostri prodotti',
          url: '#',
        },
        {
          pk: 3,
          name: 'Il pianeta',
          style: 'pianeta-illustration',
          description:
            '<p>Aiutiamo le nuove famiglie a gestire tutti gli aspetti della genitorialità.</p>',
          ctaLabel: 'B-Corp',
          url: '#',
        },
      ],
    },
  ]

  const { menu } = useSelector((state) => state.menu)
  const manifestoMenu = menu?.find((item) => item.key === 'manifesto')
  const items = manifestoMenu?.children || []

  return (
    <Page pagina={pagina} item={pagina}>
      <div className={styles.impegnoTemplate}>
        <RoundHead
          breadcrumbs={pagina.breadcrumbs}
          title={pagina.titolo}
          description={pagina.descrizione}
          color="white"
          className={styles.head}
          readMore={false}
        />
        {items.length > 0 && (
          <div className={styles.main}>
            <ImpegnoSection1 item={items[0]} />
            <ImpegnoSection2 item={items[1]} />
            <ImpegnoSection3 item={items[2]} />
            <ImpegnoSection4 item={items[3]} />
            <ImpegnoSection5 item={items[4]} />
            <ImpegnoSection6 item={items[5]} />
          </div>
        )}
      </div>
    </Page>
  )
}

export default ImpegnoTemplate
